import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DevOpsPlaceholderCardComponent } from '../devops-placeholder-card/devops-placeholder-card.component';

@Component({
  selector: 'app-devops-pipeline-health',
  imports: [DevOpsPlaceholderCardComponent],
  templateUrl: './devops-pipeline-health.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevOpsPipelineHealthComponent {}
